import { createSlice } from '@reduxjs/toolkit';

const initialAuthState = {
    isAuthenticated: false,
    isLoginModalVisible: false,
    onboardingModalVisible: false,
    token: null,
    userId: null,
    userHash: null,
    userName: null,
    userRole: null,
    eligibleRoles: null,
    userDetails: {},
    address: {},
    unauthorizedUser: false,
    unauthorizedUserMessage: null,
    profileCompletionPercentage: null,
    finishedFirstTimeLoginGuide: null,
    showSessionTimeout: false,
    rewardPoints: null,
    reloyRewardPoints: null,
    totalRewards: null
};

const authSlice = createSlice({
    name: 'authentication',
    initialState: initialAuthState,
    reducers: {
        login(state) {
            console.log('loging in');
            state.isAuthenticated = true;
            state.showSessionTimeout = false;
        },
        logout(state) {
            // localStorage.removeItem('accessToken');
            // localStorage.removeItem('refreshToken');
            console.log('loging out');

            state.isAuthenticated = false;
            state.token = null;
            state.userName = null;
            state.userRole = null;
            state.eligibleRoles = null;
            state.userId = null;
            state.userHash = null;
            state.userDetails = {};
            state.address = {};
            state.profileCompletionPercentage = null;
            state.showSessionTimeout = false;
            state.reloyRewardPoints = null;
            state.rewardPoints = null;
            state.totalRewards = null;
        },
        openLoginModal(state) {
            state.isLoginModalVisible = true;
            state.showSessionTimeout = false;
        },
        closeLoginModal(state) {
            state.isLoginModalVisible = false;
            state.showSessionTimeout = false;
        },
        authenticationToken(state, action) {
            state.token = action.payload;
            state.showSessionTimeout = false;
        },
        setRewardPoints(state, action) {
            state.rewardPoints = action.payload;
        },
        setReloyRewardPoints(state, action) {
            state.reloyRewardPoints = action.payload;
        },
        setTotalRewards(state, action) {
            state.totalRewards = action.payload;
        },
        setUserData(state, action) {
            // console.log(action.payload);
            state.userDetails = action.payload.userDetails;
            state.address = action.payload.address;
            state.userName = action.payload.name;
            state.userRole = action.payload.userRole;
            state.eligibleRoles = action.payload.eligibleRoles;
            state.userId = action.payload.userId;
            state.userHash = action.payload.hashId;
            state.profileCompletionPercentage =
                action.payload.profileCompletionPercentage;
            state.finishedFirstTimeLoginGuide =
                action.payload.finishedFirstTimeLoginGuide;
        },
        setProfileCompletionPercentage(state, action) {
            state.userDetails = action.payload.userDetails;
            state.profileCompletionPercentage =
                action.payload.profileCompletionPercentage;
        },
        setFinishedFirstTimeLoginGuide(state, action) {
            state.finishedFirstTimeLoginGuide = action.payload;
        },
        setUnauthorizedUser(state, action) {
            state.unauthorizedUser = true;
            state.unauthorizedUserMessage = action.payload;
        },
        openOnboardingModal(state) {
            state.onboardingModalVisible = true;
        },
        closeOnboardingModal(state) {
            state.onboardingModalVisible = false;
        },
        setSessionTimeout(state, action) {
            // console.log('inside session', action.payload);
            state.showSessionTimeout = action.payload;
        },
        setUserHash(state, action) {
            state.userHash = action.payload;
        },
        setUserMobile(state, action) {
            return {
                ...state,
                userDetails: { ...state.userDetails, ...action.payload },
                address: { ...state.address, ...action.payload }
            };
        }
    }
});

export const authActions = authSlice.actions;
export default authSlice;
